module.exports = __webpack_public_path__ + "img/icon_list-04.116ee47f.svg";